import React from "react";
import { Link, Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Toaster } from "sonner";

export default function AdminLayout() {
  const { user, loading, logout, impersonating } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  if (loading) return <div className="p-10 text-center text-[#5C5657]">Caricamento…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  // Se lo staff è in modalità "Accedi come" (impersonation), NON deve poter navigare
  // dentro il pannello Admin con la sessione agency attiva — verrebbero mostrate viste
  // vuote perché il ruolo attivo è "agency". Rimandiamo all'Area Agenzie da cui potrà
  // uscire con il bottone "Esci dalla visualizzazione" nel banner rosso.
  if (impersonating) return <Navigate to="/area-agenzie" replace />;

  const links = [
    { to: "/admin", label: "Dashboard", exact: true },
    { to: "/admin/immobili", label: "Immobili" },
    { to: "/admin/venditori", label: "Venditori" },
    { to: "/admin/agenzie", label: "Agenzie" },
    { to: "/admin/tecnici", label: "PTI e Aziende" },
    { to: "/admin/leads", label: "Richieste" },
    { to: "/admin/registro-richieste", label: "Registro Richieste" },
    { to: "/admin/richieste-documentazione", label: "Richieste documentazione" },
    { to: "/admin/audit", label: "Audit log" },
  ];
  const active = (l) => l.exact ? loc.pathname === l.to : loc.pathname.startsWith(l.to);

  const onLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#F4F3F1] flex" data-testid="admin-layout">
      <Toaster position="top-right" richColors />
      <aside className="w-64 border-r border-[#E6E4E0] bg-white flex flex-col">
        <div className="p-6 border-b border-[#E6E4E0]">
          <Link to="/admin">
            <div className="font-serif text-lg text-[#7D2E3F] tracking-[0.12em] leading-none">PRONTO ALLA VENDITA</div>
            <div className="label-uppercase mt-1 text-[10px]">by RX CASA · Gestionale</div>
          </Link>
        </div>
        <nav className="flex-1 py-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`admin-nav-${l.label.toLowerCase().replace(" ","-")}`}
              className={`block px-6 py-3 text-sm border-l-2 ${active(l) ? "border-[#7D2E3F] bg-[#F2EBEB] text-[#7D2E3F]" : "border-transparent hover:bg-[#F4F3F1]"}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="border-t border-[#E6E4E0] p-4">
          <div className="text-xs text-[#5C5657]">{user.name}</div>
          <div className="text-xs text-[#3A3D42] mb-3 truncate">{user.email}</div>
          <button data-testid="admin-logout" onClick={onLogout} className="w-full text-xs label-uppercase border border-[#E6E4E0] py-2 hover:border-[#7D2E3F] hover:text-[#7D2E3F]">Esci</button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto">
        <div className="p-8 max-w-[1400px]"><Outlet /></div>
      </main>
    </div>
  );
}
